import React from "react";
import { useSelector } from "react-redux";
import { Box } from "@remo-co/ui-core/src/components/Box";
import { Typography } from "@remo-co/ui-core/src/components/Typography";
import { Button } from "@remo-co/ui-core/src/components/Button";
import { Input } from "@remo-co/ui-core/src/components/Input";
import { selectMyCompany } from "modules/company/redux/selectors";
import useNotificationActions from "modules/notification/hooks/useNotificationActions";
import { useI18n } from "i18n";
import { selectExitDoorUrl } from "modules/companySettings/redux/selectors";
import useCompanySettingsActions from "../../../companySettings/hooks/useCompanySettingsActions";
import { updateExitURL } from "../../../../services/apiService/apis";
import { styles } from "./styles";

export const ExitDoorEdit = () => {
  const company = useSelector(selectMyCompany);
  const { setCompanySettings } = useCompanySettingsActions();
  const { addErrorNotification, addSuccessNotification } =
    useNotificationActions();
  const exitURL = useSelector(selectExitDoorUrl);
  const [value, setValue] = React.useState<string>(exitURL);

  React.useEffect(() => {
    if (exitURL) {
      setValue(exitURL);
    }
  }, [exitURL]);

  const onChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    setValue(e.target.value);
  };

  const { t } = useI18n();

  const save = async () => {
    if (company && company.id) {
      const res = await updateExitURL(company.id, value.trim());

      if (!res.isSuccess) {
        addErrorNotification({
          message: t("failed.save.url"),
          autoDismiss: 5,
        });

        return;
      }

      if (res.companySettings) {
        setCompanySettings(res.companySettings);
      }
      addSuccessNotification({
        message: t("success.save.url"),
        autoDismiss: 5,
      });
    }
  };

  return (
    <Box sx={styles.exitDoorEditCtn}>
      <Typography variant="h3" color="textPrimary">
        {t("custom.exit.page.url")}
      </Typography>
      <Typography color="textPrimary" sx={styles.description}>
        {t("use.custom.url")}
      </Typography>

      <Box sx={styles.inputCtn}>
        <Input
          label={t("exit.page.url")}
          name="exitPageUrl"
          placeholder={t("placeholder.custom.url")}
          value={value}
          onChange={onChange}
          size="sm"
          fullWidth
        />
        <Button type="submit" variant="secondary" color="blue" onClick={save}>
          {t("button.save")}
        </Button>
      </Box>
    </Box>
  );
};
